export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  // Decode URLs to handle encoded characters like %20 (space)
  const decodedCurrent = decodeURIComponent(current)
  const decodedUrl = decodeURIComponent(url)

  // Normalize paths by removing trailing slashes
  const normalizedCurrent = decodedCurrent.replace(/\/$/, '') || '/'
  const normalizedUrl = decodedUrl.replace(/\/$/, '') || '/'

  // Exact match
  if (normalizedCurrent === normalizedUrl) {
    return true
  }

  // Check if current path is a sub-path of the menu item
  // Only match if it's a proper sub-path (followed by a slash)
  if (normalizedUrl !== '/' && normalizedCurrent.startsWith(normalizedUrl + '/')) {
    return true
  }

  return false
}
